




















































































































































































































































import moment from "moment";
import { translations } from "@/mixins";
import Translations from "../components/Translations.vue";
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Promotion } from "@/services/SOLO";

@Component({
  components: {
    Translations
  },
  mixins: [translations]
})
export default class PromotionsList extends Vue {
  hasList: boolean = true;
  promotions: Array<any> = [];

  created() {
    Promotion.fetchPromotions().then(response => {
      // console.log("promotionData: ", response);
      this.promotions = response.data.data;
      // console.log("promotionsResponse: ", this.promotions);
    });
  }

  onAddPromotion() {
    this.$router.push({
      name: "PromotionsCreate"
    });
  }

  onEditPromotion(promotion: any) {
    this.$router.push({
      path: `/promotions/edit/${promotion.id}`
    });
  }

  formatDate(date: Date) {
    console.log(moment.locale());
    return moment
      .utc(date)
      .locale("en-us")
      .local()
      .format("ll");
  }
}
